import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import type { ILinkProps, ILinkStyleProps, ILinkStyles } from '@fluentui/react/lib/Link';
import type { IStyleFunction } from '@fluentui/react/lib/Utilities';
import { getPalette, getPaletteAsRawColors } from 'owa-theme';

interface LinkColorScheme {
    linkColor: string;
    linkHoverColor: string;
}

const generateLinkStyle = (
    colorScheme: ColorScheme,
    backgroundColor?: string
): IStyleFunction<ILinkProps, ILinkStyles> => {
    if (!colorScheme) {
        return null;
    }

    const background = backgroundColor || getPaletteAsRawColors().white;
    return generateStyleFunctionFromColor({
        linkColor: getOptimalTextColorString(background, colorScheme, colorScheme.calPrimary),
        linkHoverColor: getOptimalTextColorString(background, colorScheme, colorScheme.calDarker),
    });
};

const generateStyleFunctionFromColor = (
    linkColor: LinkColorScheme
): IStyleFunction<ILinkProps, ILinkStyles> => {
    return (props: ILinkStyleProps): ILinkStyles => {
        const { isDisabled } = props;
        return {
            root: [
                isDisabled && {
                    color: getPalette().neutralSecondary,
                },
                !isDisabled && [
                    {
                        color: linkColor.linkColor,
                    },
                    {
                        selectors: {
                            '&:active, &:hover, &:active:hover': {
                                color: linkColor.linkHoverColor,
                                textDecoration: 'none',
                            },
                            '&:focus': {
                                color: linkColor.linkColor,
                            },
                        },
                    },
                ],
            ],
        };
    };
};

export default generateLinkStyle;
